
import Vue from 'vue'
import MobileMenu from './MobileMenu/MobileMenu.vue'

export default Vue.extend({
  components: { MobileMenu },
  name: 'AppBar',

  data () {
    return {
      scrollPos: 0,
      langs: [
        { id: 1, title: 'En' },
        { id: 1, title: 'Ru' },
        // { id: 1, title: 'Ua' }
      ],
      selectedLang: 'En',
      whatsappUrl: 'https://api.whatsapp.com/send/?phone=447988898671&text=Hi%20there%21%20I%E2%80%99d%20like%20to%20find%20out%20more%20about%20the%20solutions%20provided%20by%20ARI.company.%20When%20would%20be%20a%20good%20time%20to%20connect%20and%20discuss%20how%20your%20services%20can%20benefit%20me%3F&type=phone_number&app_absent=0'
    }
  },

  computed: {
    banner () {
      return this.$store.getters.banner
    },
    stickyClass () {
      if (this.banner && this.scrollPos > 100) {
        return 'app-bar-banner-fixed'
      }
      if (!this.banner && this.scrollPos > 0) {
        return 'app-bar-fixed'
      }
      return ''
    }
  },

  mounted () {
    window.addEventListener('scroll', this.updateScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.updateScroll)
  },

  methods: {
    updateScroll() {
      this.scrollPos = window.scrollY
    },
    selectLanguage (e: string): void {
      this.selectedLang = e
    },
    openMobileMenu () {
      this.$store.dispatch('UI/mobileMenu', true)
    }
  }
})
